import React from "react"

import SignUpFormPageMetaTagsAndOpenGraphInfo from "./Seo_metaTags_openGraph_Info"
import AcademyPageStuctredDataUsingJSONLD from "./SeoStructuredData"

const Seo = () => {
  return (
    <>
      <SignUpFormPageMetaTagsAndOpenGraphInfo />
      <AcademyPageStuctredDataUsingJSONLD />
    </>
  )
}

export default Seo
